

// For Mobile
if (document.querySelector(".mobile_carousel")) {
document.addEventListener("DOMContentLoaded", function () {
function mob_init() {
  const carousel_Elem = document.querySelector(".mobile_carousel");
  const mobile_slides = carousel_Elem.querySelectorAll('.gallery__item');
  const is_Mobile = window.matchMedia('screen and (max-width: 798px)').matches;

  // Set options based on slide count
  const flickity_Options = {
    imagesLoaded: true,
    contain: true,
    cellAlign: "left",
    prevNextButtons: true,
    draggable: is_Mobile ? true : mobile_slides.length !== 3,
    wrapAround: true
  };

const mobile_flkty = new Flickity(carousel_Elem, flickity_Options);

    setTimeout(() => {
    mobile_flkty.resize(); 
  }, 100);
  const button_Wrapper = document.createElement('div');
  button_Wrapper.className = "custom_flickity_button";

  const mobile_buttons = carousel_Elem.querySelectorAll('.flickity-button');
  mobile_buttons.forEach(mob_button => button_Wrapper.appendChild(mob_button));
carousel_Elem.appendChild(button_Wrapper);

}
window.addEventListener("DOMContentLoaded", mob_init);
  });
document.querySelector('.next').addEventListener('click', function () {
  mobile_flkty.resize(); // Fix potential layout issue
  mobile_flkty.next();   // Move to next slide
});
}